import { render, staticRenderFns } from "./goods-order-verify.vue?vue&type=template&id=2e7f77f2&"
import script from "./goods-order-verify.vue?vue&type=script&lang=js&"
export * from "./goods-order-verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports